/**
 * @generated SignedSource<<ca1d82d7fbbde7bbfd7214a4f08b5baa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ObjectiveVisibility = "PRIVATE" | "PUBLIC";
export type keyResultQuery$variables = {
  id: string;
};
export type keyResultQuery$data = {
  readonly keyResult: {
    readonly assigneeTeam?: {
      readonly id: string;
      readonly title: string;
    } | null;
    readonly assigneeUser?: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isGuest: boolean;
    } | null;
    readonly id?: string;
    readonly metricCurrent?: number;
    readonly metricTarget?: number;
    readonly objective?: {
      readonly contributors: ReadonlyArray<{
        readonly email: string;
        readonly id: string;
      }>;
      readonly contributorsTeams: ReadonlyArray<{
        readonly id: string;
        readonly isAccountWideTeam: boolean;
        readonly members: ReadonlyArray<{
          readonly email: string;
          readonly id: string;
        }>;
      }>;
      readonly hasAccess: boolean;
      readonly id: string;
      readonly title: string;
      readonly visibility: ObjectiveVisibility;
    };
    readonly progress?: number;
    readonly title?: string;
  } | null;
};
export type keyResultQuery = {
  response: keyResultQuery$data;
  variables: keyResultQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metricCurrent",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metricTarget",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assigneeUser",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "assigneeTeam",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v7/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Objective",
  "kind": "LinkedField",
  "name": "objective",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "contributors",
      "plural": true,
      "selections": (v10/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "contributorsTeams",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccountWideTeam",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "members",
          "plural": true,
          "selections": (v10/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "keyResultQuery",
    "selections": [
      {
        "alias": "keyResult",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/)
            ],
            "type": "KeyResult",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "keyResultQuery",
    "selections": [
      {
        "alias": "keyResult",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/)
            ],
            "type": "KeyResult",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c8fecb63f500d23bbd88e358d1e77e6",
    "id": null,
    "metadata": {},
    "name": "keyResultQuery",
    "operationKind": "query",
    "text": "query keyResultQuery(\n  $id: ID!\n) {\n  keyResult: node(id: $id) {\n    __typename\n    ... on KeyResult {\n      id\n      title\n      metricCurrent\n      metricTarget\n      progress\n      assigneeUser {\n        id\n        email\n        image\n        fullName\n        isGuest\n      }\n      assigneeTeam {\n        id\n        title\n      }\n      objective {\n        id\n        title\n        hasAccess\n        visibility\n        contributors {\n          id\n          email\n        }\n        contributorsTeams {\n          id\n          isAccountWideTeam\n          members {\n            id\n            email\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4972f81f01ac3c3a16dbffc86c970d42";

export default node;
